import React, { FunctionComponent } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { useSpecificParams } from 'record-it-components/hooks/useSpecificParams/useSpecificParams';
import { CreateConstructionSitePageContent } from '../../constructionSite/CreateConstructionSitePageContent/CreateConstructionSitePageContent';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';

export type ConstructionSiteAdminCreateConstructionSitePageProps =
  PropsWithoutChildren<Record<never, never>>;

export const ConstructionSiteAdminCreateConstructionSitePage: FunctionComponent<ConstructionSiteAdminCreateConstructionSitePageProps> =
  React.memo((props) => {
    prepareProps({ props, ignoreChildren: true });

    const { userGroupId } = useSpecificParams({
      requiredParamNames: ['userGroupId']
    });
    const navigate = useNavigate();

    useConfigureBreadcrumbsWithBuilder((builder) =>
      builder
        .addHomePage()
        .addConstructionSiteAdminPage()
        .addConstructionSiteAdminCreateConstructionSitePage(userGroupId)
    );

    const handleConstructionSiteCreated = useEventCallback(() => {
      navigate(RoutePaths.adminConstructionSites());
    });

    const handleCancel = useEventCallback(() => {
      navigate(RoutePaths.adminConstructionSites());
    });

    return (
      <CreateConstructionSitePageContent
        userGroupId={userGroupId}
        onCancel={handleCancel}
        onConstructionSiteCreated={handleConstructionSiteCreated}
        data-testid="ConstructionSiteAdminCreateConstructionSitePage.PageContent"
      ></CreateConstructionSitePageContent>
    );
  });
